import { NuxtAxiosInstance } from '@nuxtjs/axios'
import qs from 'qs'

interface queryParams {
  [key: string]: any
}

export default class BaseRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor (protected endpoint: string, protected $axios: NuxtAxiosInstance) {}

  public index (params?: queryParams): Promise<any> {
    return this.$axios.get(`${this.endpoint}`, {
      params,
      paramsSerializer: params => qs.stringify(params)
    })
  }

  public show (id: number): Promise<any> {
    return this.$axios.get(`${this.endpoint}/${id}`)
  }

  public delete (id: number): Promise<any> {
    return this.$axios.delete(`${this.endpoint}/${id}`)
  }
}
